var map = {
	"./BaseWidgetForm.vue": "306b",
	"./ButtonWidget.vue": "a27d",
	"./CaseStudyWidget.vue": "80ed",
	"./FormWidget.vue": "d023",
	"./ImageWidget.vue": "a62d",
	"./ImageWithTextWidget.vue": "994d",
	"./LeadWidget.vue": "a72d",
	"./MiddleImageWidget.vue": "5375",
	"./MiddleTextWidget.vue": "ed88",
	"./NewsWidget.vue": "4ef3",
	"./ProjectDescriptionWidget.vue": "1421",
	"./QuoteWidget.vue": "aa09",
	"./SidedAgendaWithNumerationWidget.vue": "c78b",
	"./SliderWidget.vue": "1d41",
	"./SubtitleWithSidedAgendaWidget.vue": "23d1",
	"./TabWidget.vue": "d03f",
	"./TextWithHeaderWidget.vue": "a6be",
	"./TitularWidget.vue": "bf7d",
	"./TwoColumnsWidget.vue": "eac5",
	"./VideoWidget.vue": "733b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f7e1";